import { render, staticRenderFns } from "./OffersGroupTable.vue?vue&type=template&id=33427424"
import script from "./OffersGroupTable.vue?vue&type=script&lang=js"
export * from "./OffersGroupTable.vue?vue&type=script&lang=js"
import style0 from "./OffersGroupTable.vue?vue&type=style&index=0&id=33427424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports